import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, withStyles } from "@material-ui/core";
import { dateFormatterMomentV4 } from "../../util/customFunctions";
import Skeleton from "@material-ui/lab/Skeleton";
import HoverableIcon from "../../components/Buttons/HoverableIcon ";
import { replaceDynamicValueLabel } from "../../util/utils";
import Tooltip from "@material-ui/core/Tooltip";
import PipelineTableHome from "../TimeSeriesPrediction/PipelineTableHome";
import LowMIdHighTableHome from "../TimeSeriesPrediction/LowMidHighTableHome";
import ReusableAgGrid from "../../components/AgGrid/AgGrid";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "rgb(255,255,255,0.8)",
    color: "black",
    fontFamily: "roboto",
    fontSize: theme.typography.pxToRem(14),
    borderRadius: "1rem",
    padding: "0px",
    boxShadow: "0 0.1rem 0.1rem 0",
    marginTop: "0.4rem",
  },
}))(Tooltip);

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  titleContainer: {
    width: "100%",
  },
}));

const compareOultiers = (data1, data2) => {
  const arr = data1.map((item) => {
    const item2 = data2.find((i2) => i2.OppName === item.OppName);
    return item2
      ? { ...item, ...item2 }
      : {
          ...item,
          ML_Expected_ACV: "Outlier Opp.",
          ML_Final_Probability_Score: "Outlier Opp.",
        };
  });

  return arr;
};

const DrilldownSLDNewv2 = (props) => {
  const [exportTrigger, setExportTrigger] = useState(0); // Each time we click, the number changes, triggering the useEffect in the child.

  console.log("DrilldownSLD", props);
  const classes = useStyle();

  //projected yield toottip
  const projectedYieldTooltip = (
    <>
      {Array(1)
        .fill()
        .map((item) => (
          <>
            <div
              style={{
                borderTop: "solid #4471C4",
                borderRadius: "0.3rem",
                padding: "0px",
                margin: 0,
                borderWidth: "0.3rem",
              }}
            >
              <div className="container">
                <Typography
                  style={{ padding: "0.1rem" }}
                  className="heading-style"
                >{`SkyGeni Projected Yield from opps. in ${props.header}`}</Typography>
              </div>
            </div>
          </>
        ))}
    </>
  );

  //projected attainment tooltip
  const projectedAttainmentTooltip = (
    <>
      {Array(1)
        .fill()
        .map((item) => (
          <>
            <div
              style={{
                borderTop: "solid #4471C4",
                borderRadius: "0.3rem",
                padding: "0px",
                margin: 0,
                borderWidth: "0.3rem",
              }}
            >
              <div className="container">
                <Typography
                  style={{ padding: "0.1rem" }}
                  className="heading-style"
                >{`Won + SkyGeni Projected Yield from opps. in ${props.header}`}</Typography>
              </div>
            </div>
          </>
        ))}
    </>
  );

  let acvLabel = props.acvName ? `${props.acvName}:` : "ACV";
  if (props.Value_Label) {
    acvLabel = replaceDynamicValueLabel(acvLabel, props.Value_Label);
  }

  const convertedData =
    props.body &&
    (props.toggleValue === true
      ? compareOultiers(
          props.body.opportunities,
          props.body.message.opportunities[3]
        )
      : props.body.opportunities);

  const onCellClicked = (e) =>
    props.handleSecondLevelDrilldown("drilldownOppId", e.data.Opp_ID);

  const handleExport = () => {
    // Each time we click, the number changes, triggering the useEffect in the child.
    setExportTrigger((prevCount) => prevCount + 1);
  };

  return (
    <Grid
      container
      className={classes.root}
      data-test={props.type ? `drilldown-${props.type}` : "drilldown"}
    >
      {props.body ? (
        <React.Fragment>
          <Grid
            container
            justifyContent="space-between"
            className={classes.titleContainer}
          >
            {/* Wrapper Grid to ensure proper alignment */}
            <Grid
              item
              xs={12}
              container
              justifyContent="flex-start"
              alignItems="flex-end"
            >
              {props.showLowMidHigh && props.pipeline && (
                <Grid container spacing={2} sx={{ width: "100%", mx: "auto" }}>
                  {/* LowMidHigh Table */}
                  <Grid item xs={12} md={6}>
                    <LowMIdHighTableHome
                      winAcvData={props.expectedHighMidLow}
                      quarterLastDate={props.quarterLastDate}
                      showDifference={false}
                      closedWonAfterOffset={false}
                      Value_Label={props.Value_Label}
                      showHeight="N"
                      title={`Projection for ${props.fiscalQuarter}`}
                    />
                  </Grid>

                  {/* Qualified Pipeline Table */}
                  <Grid item xs={12} md={6}>
                    <PipelineTableHome
                      title="Qualified Pipeline"
                      winAcvData={props.qualifiedPipeline}
                      splitType={props.splitType}
                      uniqueNames={props.uniqueNames}
                      Value_Label={props.Value_Label}
                      firstCell="count"
                      secondCell="acv"
                      thirdCell="perc"
                      tableHeader="Qualified Pipeline"
                      drilldownHeader="Qualified Pipeline"
                      cellHeader1="Opps"
                      cellHeader2={props.Value_Label}
                      cellHeader3="% of Tot."
                      key1="Projected"
                      key2="Projected"
                      dataTest="qualified-pipeline"
                      tableHeader1={
                        props.quarterLastDate
                          ? `As of ${dateFormatterMomentV4(
                              props.quarterLastDate
                            )}`
                          : ""
                      }
                      showHeight="N"
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>

          <Grid
            container
            xs={12}
            justifyContent="flex-end"
            alignItems="flex-end"
          >
            <Grid
              direction="column"
              item
              container
              xs={1}
              justifyContent="flex-end"
              alignItems="flex-end"
              alignContent="flex-end"
            >
              <Grid
                item
                justifyContent="flex-end"
                style={{ paddingBottom: "0.3rem" }}
              >
                <button style={{ border: "none" }} onClick={handleExport}>
                  <HoverableIcon />
                </button>
              </Grid>
            </Grid>
          </Grid>

          <ReusableAgGrid
            rowData={convertedData}
            columnConfig={props.body.columns}
            onCellClicked={props.showSLD ? onCellClicked : null}
            isExportable={true}
            header={props.header}
            rawColumnDataForExport={props.body.columns}
            exportTrigger={exportTrigger}
          />
        </React.Fragment>
      ) : (
        <Skeleton
          animation="wave"
          variant="rect"
          width="100%"
          height={280}
          style={{ margin: "20px 0px" }}
        />
      )}
    </Grid>
  );
};

export default DrilldownSLDNewv2;
